//Include Both Helper File with needed methods
import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetUserById, UpdateProfile } from "../../../helpers/fakebackend_helper";


export const fetchUserById = createAsyncThunk(
    "profile/fetchUserById",
    async (user, thunkAPI) => {
      try {
        const response = await GetUserById(user); 
        return response.data;
      } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
);

export const updateUserProfile = createAsyncThunk(
    "profile/updateUserProfile",
    async (user, thunkAPI) => {
      try {
        const response = await UpdateProfile(user);
        return response.data;
      } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
);
  